module.exports = __webpack_public_path__ + "img/60.8dddc026.jpg";